import { render, staticRenderFns } from "./Correcting.vue?vue&type=template&id=06bffdc0&scoped=true"
import script from "./Correcting.vue?vue&type=script&lang=js"
export * from "./Correcting.vue?vue&type=script&lang=js"
import style0 from "./Correcting.vue?vue&type=style&index=0&id=06bffdc0&prod&lang=scss&scoped=true"
import style1 from "./Correcting.vue?vue&type=style&index=1&id=06bffdc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bffdc0",
  null
  
)

export default component.exports